import { AadConfigModel } from '@connect/shared/models/aad-config.model';
import { ApiConfigModel } from '@connect/shared/models/api-config.model';

export class ConfigModel {
    public aad: AadConfigModel;
    public api: ApiConfigModel;
}
